<template>
  <b-sidebar
    id="sidebar-right-tasks"
    right
    backdrop
    backdrop-variant="dark"
    no-close-on-route-change
    no-close-on-backdrop
    lazy
    body-class="p-0"
    no-header
    :width="width"
  >
    <template #default="{ hide }">
      <div class="detail-widget">
        <div class="detail-widget__top">
          <b-icon-arrow-bar-left
            class="detail-widget__back cursor-pointer"
            font-scale="2"
            @click="closeSidebar"
          />
          <h2 class="mb-0 text-light">Создание задачи</h2>
        </div>

        <div class="detail-widget__card">
          <div class="mb-4">
            <label for="type-reference-task">Тип задачи</label>
            <b-form-select v-model="taskData.reference_type_id" :options="options"></b-form-select>
          </div>

          <div class="mb-4">
            <label for="title-task" class="m-0">Заголовок</label>
            <input
              type="text"
              class="form-control bg-white"
              id="title-task"
              placeholder="Введите название задачи..."
              v-model="taskData.title"
            >
          </div>

          <div class="mb-4">
            <label for="description-task" class="m-0">Описание</label>
            <textarea
              cols="30"
              rows="2"
              class="form-control bg-white"
              id="description-task"
              style="min-height: 74px;  max-height: 500px;"
              placeholder="Введите описание задачи..."
              v-model="taskData.description"
            ></textarea>
          </div>

          <div class="mb-4">
            <label for="date-realization-task" class="m-0">Дата исполнения</label>
            <input
              type="datetime-local"
              class="form-control bg-white"
              id="date-realization-task"
              v-model="taskData.realization_at"
            >
          </div>

          <div class="mb-2">
            <label for="realizator-task" class="m-0">Исполнитель</label>
            <tsoft-select-user
              id="realizator-task"
              :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||administrator||bsz-manager||b2c-head-manager||b2c-manager||lawyer-manager||lawyer-head-manager||hr-manager||hr-head-manager||agent`"
              :needNullElement="false"
              :selectedArray="taskData.realizator_user_id"
              :needMultipleSelect="true"
              @set="setRealizatorUserId"
            ></tsoft-select-user>
          </div>

          <div class="text-left">
            <small class="no-wrap"><b class="text-danger">*</b>по умолчанию Вы будете назначены исполнителем.</small>
          </div>
        </div>
        <div class="sticky-save-block mt-auto p-3">
          <div class="d-flex">
            <button @click="createTask" class="btn btn-sm btn-success mr-2 px-3">Создать</button>
            <button @click="closeSidebar" class="btn btn-sm btn-primary px-3">Отмена</button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_TASKS } from '@/constants';
import { defaultDataItems } from '@/mixins';

export default {
  props: {
    width: { type: String, default: '50%' },
    orderId: { type: String|Number, default: ''},
    elementIds: {
      type: Array,
      default: () => [],
    }, // Array of elements ids for creating mass tasks
    elementDBField: { type: String|Number, default: ''}, // For creating mass task we need to know what type are them: order_id, company_id, finance_id
    companyId: { type: String|Number, default: ''},
    financeId: { type: String|Number, default: ''},
    orderServiceId: { type: String|Number, default: ''},
    realizationData: { type: String, default: '' },
  },

  mixins: [defaultDataItems],

  data() {
    return {
      selectedPerformers: [],
      taskData: {
        order_id: '',
        company_id: '',
        finance_id: '',
        order_service_id: '',
        title: '',
        description: '',
        realization_at: this.$moment().add(1, 'hours').format('YYYY-MM-DDTHH:mm'),
        reference_type_id: '406',
        realizators: []
      },
      options: [
        { value: '405', text: 'Связаться', title: 'Необходимо связаться с клиентом' },
        { value: '404', text: 'Встреча', title: 'Встреча с клиентом' },
        { value: '547', text: 'Узнать ответ на КП', title: 'Узнать ответ на КП' },
        { value: '548', text: 'Договор', title: 'Получить обратную связь по договору' },
        { value: '406', text: 'Другое' }
      ],
    }
  },

  computed: {
    ...mapGetters('auth', ['currentUser'])
  },

  watch: {
    'taskData.reference_type_id': function(reference_type_id) {
      this.taskData.title = '';
      if (!this.taskData.title) {
        let findElem = this.options.find((element) => {
          if (element.value == reference_type_id) {
            return element
          }
        })

        if (findElem !== 'undefined') {
          this.taskData.title = findElem.title
        }
      }
    },
    orderId: {
      handler(value) {
        this.taskData.order_id = value
      },
      immediate: true
    },
    companyId: {
      handler(value) {
        this.taskData.company_id = value
      },
      immediate: true
    },
    financeId: {
      handler(value) {
        this.taskData.finance_id = value
      },
      immediate: true
    },
    orderServiceId: {
      handler(value) {
        this.taskData.order_service_id = value
      },
      immediate: true
    },
    realizationData() {
      if (this.realizationData) {
        this.taskData.realization_at = this.realizationData
      }
    }
  },

  methods: {
    createTask() {
      let usersArray = [];

      for (let realizatorItem in this.selectedPerformers) {
        let selectedUsers = {
          realizator_user_id: this.selectedPerformers[realizatorItem],
        };
        usersArray.push(selectedUsers);
      }

      if (this.selectedPerformers.length == 0) {
        usersArray.push({realizator_user_id: this.currentUser.id})
      }

      this.taskData.realizators = usersArray;

      // Признак массовой задачи для бэкенда
      if (this.elementIds.length > 0) {
        this.taskData.elementIds = this.elementIds
        this.taskData.elementDBField = this.elementDBField
      }

      if (!this.taskData.title) return

      api.call('post', API_TASKS, this.taskData)
        .then(({data}) => {
          this.$emit('setNewCreatedTask', data);

          usersArray = [];

          this.makeToast('success', 'Задача создана');
          this.closeSidebar();
          this.setToGetAllHistoryTasks();
        })
    },
    closeSidebar() {
      this.resetData();
      this.$emit('openCreateTaskSidebar');
    },
    setRealizatorUserId(id) {
      this.selectedPerformers = id
    },
    setToGetAllHistoryTasks() {
      this.$emit('setToGetAllHistoryTasks');
    },
    resetData() {
      this.taskData = {
        order_id: '',
        company_id: '',
        finance_id: '',
        order_service_id: '',
        title: '',
        description: '',
        realization_at: '',
        reference_type_id: '406',
        realizators: []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;
.detail-widget {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  &__top {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 24px;
  }

  &__card {
    padding: 24px;
    flex: 1;
    overflow-x: hidden;
  }

  &__back {
    margin-right: 10px;
    width: 30px;
    height: 30px;
  }
}
.sticky-save-block {
    position: sticky;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    text-align: right;
    width: 100%;
    background: #dbdbdba6;
  }
</style>
